import { animaliaListingDesignTokens } from '../../shared/animalia-listing-design-tokens';

export class MvAnimaliaListingCardMedia extends HTMLElement {
  private badge = '';

  private imageSrc: string | null = null;

  private imageAlt = '';

  private imageLicenseName: string | null = null;

  private imageLicenseUrl: string | null = null;

  private imageArtist: string | null = null;

  private imageAttributionRequired = false;

  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
  }

  setMedia(
    _positionLabel: string,
    badge: string,
    imageSrc: string | null,
    imageAlt: string,
    imageLicenseName: string | null,
    imageLicenseUrl: string | null,
    imageArtist: string | null,
    imageAttributionRequired: boolean,
  ): void {
    this.badge = badge;
    this.imageSrc = imageSrc;
    this.imageAlt = imageAlt;
    this.imageLicenseName = imageLicenseName;
    this.imageLicenseUrl = imageLicenseUrl;
    this.imageArtist = imageArtist;
    this.imageAttributionRequired = imageAttributionRequired;
    this.render();
  }

  connectedCallback(): void {
    this.render();
  }

  private render(): void {
    if (!this.shadowRoot) {
      return;
    }

    const mediaContent = this.imageSrc
      ? `
          <a
            class="media-link"
            href="${this.escapeAttribute(this.imageSrc)}"
            target="_blank"
            rel="noreferrer"
            aria-label="Abrir imagen completa de ${this.escapeAttribute(this.imageAlt)} en una pestana nueva"
          >
            <img src="${this.escapeAttribute(this.imageSrc)}" alt="${this.escapeAttribute(this.imageAlt)}" loading="lazy">
          </a>
        `
      : `<div class="image-fallback" aria-hidden="true">Animalia</div>`;
    const detailBadges = [
      this.renderLicenseBadge(),
      this.renderAttributionBadge(),
      // `<span class="media-badge sea">${this.escapeHtml(this.badge)}</span>`,
      this.renderArtistBadge(),
    ]
      .filter((badge) => badge !== '')
      .join('');

    this.shadowRoot.innerHTML = `
      <style>
        ${animaliaListingDesignTokens}

        .species-media {
          display: grid;
          gap: 12px;
        }

        .species-media-frame {
          position: relative;
          min-height: 320px;
          background: #ebe5db;
        }

        .media-link {
          display: block;
          height: 100%;
        }

        img,
        .image-fallback {
          display: block;
          width: 100%;
          height: 100%;
          aspect-ratio: 16 / 10;
          object-fit: cover;
        }

        .image-fallback {
          display: grid;
          place-items: center;
          font-family: Georgia, 'Times New Roman', serif;
          font-size: 1.3rem;
          color: rgba(49, 70, 61, 0.72);
          background: linear-gradient(135deg, rgba(223, 213, 197, 0.8), rgba(95, 120, 128, 0.22));
        }

        .species-media-overlay {
          position: absolute;
          inset: 0;
          background: linear-gradient(180deg, rgba(32, 39, 32, 0.06), rgba(32, 39, 32, 0.34));
        }

        .media-badges {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;
          padding: 0 12px;
        }

        .media-badge {
          font-size: 0.5rem;
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 9px 12px;
          border-radius: 999px;
          background: rgba(18, 21, 18, 0.88);
          color: #f7f3ed;
          border: 1px solid rgba(255, 255, 255, 0.12);
          backdrop-filter: blur(6px);
          text-decoration: none;
          box-shadow: 0 8px 18px rgba(18, 21, 18, 0.14);
        }

        .media-badge.sea {
          background: rgba(41, 57, 61, 0.92);
        }

        @media (max-width: 720px) {
          .species-media-frame {
            min-height: 250px;
          }
        }
      </style>

      <div class="species-media">
        <div class="species-media-frame">
          ${mediaContent}
          <div class="species-media-overlay"></div>
        </div>
        ${detailBadges ? `<div class="media-badges">${detailBadges}</div>` : ''}
      </div>
    `;
  }

  private escapeHtml(value: string): string {
    return value
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#39;');
  }

  private escapeAttribute(value: string): string {
    return this.escapeHtml(value);
  }

  private renderLicenseBadge(): string {
    if (!this.imageLicenseName) {
      return '';
    }

    const label = `© ${this.escapeHtml(this.imageLicenseName)}`;

    if (this.imageLicenseUrl) {
      return `<a class="media-badge" href="${this.escapeAttribute(this.imageLicenseUrl)}" target="_blank" rel="noreferrer">${label}</a>`;
    }

    return `<span class="media-badge">${label}</span>`;
  }

  private renderArtistBadge(): string {
    if (!this.imageArtist) {
      return '';
    }

    return `<span class="media-badge">✎ ${this.escapeHtml(this.imageArtist)}</span>`;
  }

  private renderAttributionBadge(): string {
    if (!this.imageAttributionRequired) {
      return '';
    }

    return '<span class="media-badge">✓ atribucion</span>';
  }
}

if (!customElements.get('mv-animalia-listing-card-media')) {
  customElements.define('mv-animalia-listing-card-media', MvAnimaliaListingCardMedia);
}
